import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMessageChange,
        responseDataChange } from '../../actions/index'

import Slide from '@material-ui/core/Slide';

import ReleaserFailResponse from './releaserResponse';
import ConfirmationMessage from './deleteConfirmation';
import CloseButton from './closeButton';
import Loading from './loading';
import ConfirmationAddProgress from './ConfirmationAddProgress';
import StandByConfirmation from './standbyConfirmation';
import SignaturesFilterOption from './signaturesFilterOption';
import ReopenConfirmation from './reopenConfirmation';
import CloseConfirmation from './closeConfirmation';
import UnfulfilledStatusConfirmation from './unfulfilledStatusConfirmation';
import DateChangeConfirmation from './dateChangeConfirmation';

class Message extends React.Component{

    render(){   
        const messageConfig = this.props.popUpMessage;
        const message = this.props.popUpMessage.message ? this.props.popUpMessage.message : '';
        let closeButton = messageConfig.closeButton ? <CloseButton closeConfirmation={messageConfig.closeConfirm}/> : <div></div>
        let loading = messageConfig.loading ? <Loading/> : <div></div>
        let releaserResponse = messageConfig.releaseFail ? <ReleaserFailResponse/> : <div></div>
        let confirmationMessage = messageConfig.confirm ? <ConfirmationMessage/> : <div></div>
        let confirmationAddProgress = messageConfig.confirmAddProgress ? <ConfirmationAddProgress item={messageConfig.item}/> : <div></div>
        let standByConfirmation = messageConfig.standByConfirmation ? <StandByConfirmation cardsGroupIds={messageConfig.cardsGroupIds}/> : <div></div>
        let signaturesFilterOption = messageConfig.signaturesFilterOption ? <SignaturesFilterOption/> : <div></div>
        let reopenConfirmation = messageConfig.reopenConfirm ? <ReopenConfirmation cardsGroupIds={messageConfig.cardsGroupIds}/> : <div></div>
        let closeConfirmation = messageConfig.closeConfirm ? <CloseConfirmation cardsGroupIds={messageConfig.cardsGroupIds}/> : <div></div>
        let unfulfilledStatusConfirmation = messageConfig.unfulfilledStatusConfirmation ? <UnfulfilledStatusConfirmation cardsGroupIds={messageConfig.cardsGroupIds}/> : <div></div>
        let dateChangeConfirmation = messageConfig.dateChangeConfirmation ? <DateChangeConfirmation cardsGroupId={messageConfig.cardsGroupId} task={messageConfig.task} onCancel={messageConfig.onCancel} onConfirm={messageConfig.onConfirm}/> : <div></div>

        let styles = {zIndex: 1000000}
        return (
            <Slide style={styles} in={ this.props.popUpMessage.show } direction='down'>
                <div className="release-card-layout card-color">
                    { closeButton }
                    <h4 className='text-center px-2'>{ message }<span>{ loading }</span></h4>
                    { releaserResponse }
                    { confirmationMessage }
                    { confirmationAddProgress }
                    { standByConfirmation }
                    { signaturesFilterOption }
                    { reopenConfirmation }
                    { closeConfirmation }
                    { unfulfilledStatusConfirmation }
                    { dateChangeConfirmation }
                </div>
            </Slide>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMessage : state.popUpMessage
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        popUpMessageChange : popUpMessageChange,
        responseDataChange : responseDataChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Message)